import Calendar from './../../modules/components/Calendar';
import PricingCalculator from '../../modules/components/PricingCalculator';
import Helpers from "../../modules/Helpers";
export default class ReservationPicker {
    constructor(container, picker = null) {
        this.container = container;
        this.picker = picker;
        this.availableDates = {};
        this.selectedTime = null;
        this.selectedDate = null;
        this.ajaxApiUrl = window.localize_script.admin_ajax;
        this.dynamicDurationDays = parseInt(this.container.getAttribute('data-dynamic-duration-days') || '0');
        this.parseAvailableDates();
        this.createTimePeriodsContainer();
        this.initTotalCalculation();
        this.initGuestCounters();
        this.initDurationPicker();
        this.initCalendarPicker();
        this.initReservationButton();
        this.updateTotal();
    }
    initGuestCounters() {
        const counterButtons = this.container.querySelectorAll('.counter-controls input');
        counterButtons.forEach(input => {
            input.addEventListener('change', () => this.updateTotal());
        });
    }
    initDurationPicker() {
        this.durationInput = this.container.querySelector('#duration_days');
        if (!this.durationInput) {
            return;
        }
        this.durationInput.addEventListener('change', () => this.updateTotal());
    }
    initTotalCalculation() {
        this.groupPrice = this.container.getAttribute('data-group-price') === 'true';
        this.adultInput = this.container.querySelector('#adults');
        this.teenagerInput = this.container.querySelector('#teenagers');
        this.kidInput = this.container.querySelector('#kids');
        this.totalElement = this.container.querySelector('[data-total-amount]');
        this.totalGroupElement = this.container.querySelector('[data-total-group-amount]');
        this.regularTotalElement = this.container.querySelector('[data-regular-total-amount]');
        if (!this.adultInput || !this.totalElement && !this.groupPrice) {
            console.error('Missing form elements required for total calculation');
        }
    }
    updateTotal() {
        // For ReservationPicker, we need to create viewData from attributes
        const viewData = {
            adults_price: parseFloat(this.container.getAttribute('data-price') || '0'),
            regular_price: parseFloat(this.container.getAttribute('data-regular-price') || '0'),
            teenagers_price: parseFloat(this.container.getAttribute('data-teenagers-price') || '0'),
            kids_price: parseFloat(this.container.getAttribute('data-kids-price') || '0'),
            duration_days: 1,
            dynamic_duration_days: this.dynamicDurationDays > 0,
            units: 'Units',
            price_by_person_amount: Helpers.parseJsonString(this.container.getAttribute('data-price-by-person-amount')),
            price_by_weekday: Helpers.parseJsonString(this.container.getAttribute('data-price-by-weekday')),
        };
        const guestCounts = PricingCalculator.getGuestCounts(this.container);
        const durationDays = PricingCalculator.getDurationDays(this.container, viewData);
        const reservationDate = this.container.closest('form').querySelector('[name=reservation_date]');
        if (this.totalElement) {
            PricingCalculator.calculateAndUpdateTotal(this.totalElement, {
                viewData,
                guestCounts,
                durationDays,
                container: this.container,
                reservationDate: reservationDate ? reservationDate.value : null
            });
        }
        if (this.regularTotalElement) {
            PricingCalculator.calculateAndUpdateRegularTotal(this.regularTotalElement, {
                viewData,
                guestCounts,
                durationDays,
                container: this.container,
                reservationDate: reservationDate ? reservationDate.value : null
            });
        }
        if (this.totalGroupElement) {
            PricingCalculator.calculateAndUpdateTotal(this.totalGroupElement, {
                viewData,
                guestCounts,
                durationDays,
                container: this.container,
                reservationDate: reservationDate ? reservationDate.value : null,
                groupBooking: true
            });
        }
    }
    initReservationButton() {
        const reserveButton = this.container.querySelector('.reservation-btn');
        if (!reserveButton) {
            return;
        }
        reserveButton.addEventListener('click', (event) => {
            event.preventDefault();
            this.handleReservation();
        });
        this.timePeriodsContainer.addEventListener('change', (event) => {
            const target = event.target;
            if (target.matches('input[type="radio"]')) {
                this.selectedTime = target.getAttribute('data-time');
            }
        });
    }
    getErrorMessage(key) {
        return this.container.getAttribute(`data-error-${key}`) || '';
    }
    showErrorMessage(message) {
        const errorContainer = this.container.querySelector('#reservation-error-message');
        if (errorContainer) {
            errorContainer.textContent = message;
            errorContainer.classList.remove('hidden');
            errorContainer.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
    }
    hideErrorMessage() {
        const errorContainer = this.container.querySelector('#reservation-error-message');
        if (errorContainer) {
            errorContainer.classList.add('hidden');
        }
    }
    handleReservation() {
        var _a;
        const serviceId = (_a = this.container.querySelector('.reservation-btn')) === null || _a === void 0 ? void 0 : _a.getAttribute('data-service-id');
        const adultCount = this.adultInput ? parseInt(this.adultInput.value, 10) : 0;
        const teenagerCount = this.teenagerInput ? parseInt(this.teenagerInput.value, 10) : 0;
        const kidCount = this.kidInput ? parseInt(this.kidInput.value, 10) : 0;
        const durationDays = this.durationInput ? parseInt(this.durationInput.value, 10) : 1;
        const hasTimeOptions = this.getTimeOptionsForSelectedDate().length > 0;
        if (!serviceId || !this.selectedDate || (hasTimeOptions && !this.selectedTime) || adultCount <= 0) {
            let errorMessage = this.getErrorMessage('date');
            if (hasTimeOptions) {
                errorMessage += ', ' + this.getErrorMessage('time');
            }
            errorMessage += ' ' + this.getErrorMessage('adult');
            this.showErrorMessage(errorMessage);
            return;
        }
        this.hideErrorMessage();
        const reserveButton = this.container.querySelector('.reservation-btn');
        reserveButton.disabled = true;
        const formData = new FormData();
        formData.append('action', 'validate_reservation');
        formData.append('service_id', serviceId);
        formData.append('date', this.selectedDate);
        formData.append('time', this.selectedTime || '');
        formData.append('adults', adultCount.toString());
        formData.append('teenagers', teenagerCount.toString());
        formData.append('kids', kidCount.toString());
        formData.append('duration_days', durationDays.toString());
        formData.append('lang', document.documentElement.lang.split('-')[0]);
        fetch(this.ajaxApiUrl, {
            method: 'POST',
            body: formData,
            credentials: 'same-origin'
        })
            .then((response) => response.json())
            .then((data) => {
            if (data.success) {
                window.location.href = data.data.redirect_url;
            }
            else {
                this.showErrorMessage(data.data.message || this.getErrorMessage('process'));
                reserveButton.disabled = false;
            }
        })
            .catch((error) => {
            console.error('Reservation error:', error);
            this.showErrorMessage(this.getErrorMessage('generic'));
            reserveButton.disabled = false;
        });
    }
    initCalendarPicker() {
        const dateField = this.container.querySelector('[name=reservation_date]');
        if (dateField) {
            const firstAvailableMonth = this.findFirstAvailableMonth();
            const calendar = new Calendar({
                field: dateField,
                singleDate: true,
                format: 'YYYY-MM-DD',
                inline: true,
                parentEl: dateField.parentElement,
                disableDates: this.generateDisabledDatesArray(),
                startDate: firstAvailableMonth,
                onSelect: (date) => {
                    if (date) {
                        this.selectedDate = this.formatDate(date);
                        this.updateAvailableTimes(date);
                        this.updateTotal();
                    }
                },
                onMonthChange: () => {
                    // Delay to ensure DOM is updated after month change
                    setTimeout(() => {
                        this.autoSelectFirstAvailableDate();
                    }, 100);
                }
            });
            this.picker = calendar.getPicker();
            // Also trigger auto-selection on initial load
            setTimeout(() => {
                this.autoSelectFirstAvailableDate();
            }, 100);
        }
    }
    findFirstAvailableMonth() {
        const availableDateStrings = Object.keys(this.availableDates);
        if (availableDateStrings.length === 0) {
            return new Date(); // Fallback to current date if no dates available
        }
        // Sort dates and get the earliest one
        availableDateStrings.sort();
        const earliestDate = new Date(availableDateStrings[0]);
        // Return the first day of that month
        return new Date(earliestDate.getFullYear(), earliestDate.getMonth(), 1);
    }
    autoSelectFirstAvailableDate() {
        const availableDay = this.container.querySelector('.lightpick__day.is-available');
        if (availableDay && !this.selectedDate) {
            availableDay.dispatchEvent(new MouseEvent('mousedown', { bubbles: true }));
        }
    }
    parseAvailableDates() {
        const datesData = this.container.getAttribute('data-available-dates');
        if (datesData) {
            try {
                this.availableDates = JSON.parse(datesData);
            }
            catch (error) {
                console.error('Error parsing available dates:', error);
            }
        }
    }
    createTimePeriodsContainer() {
        this.timePeriodsContainer = document.createElement('div');
        this.timePeriodsContainer.className = 'time-periods-container';
        const dateField = this.container.querySelector('[name=reservation_date]');
        if (dateField && dateField.parentElement) {
            dateField.parentElement.after(this.timePeriodsContainer);
        }
    }
    generateDisabledDatesArray() {
        const availableDateStrings = Object.keys(this.availableDates);
        if (availableDateStrings.length === 0) {
            return [];
        }
        const availableDatesSet = new Set(availableDateStrings);
        const disabledRanges = [];
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const futureDate = new Date();
        futureDate.setFullYear(futureDate.getFullYear() + 1);
        let currentDate = new Date(today);
        let rangeStart = null;
        while (currentDate <= futureDate) {
            const dateString = this.formatDate(currentDate);
            if (!availableDatesSet.has(dateString)) {
                if (!rangeStart) {
                    rangeStart = new Date(currentDate);
                }
            }
            else {
                if (rangeStart) {
                    const rangeEnd = new Date(currentDate.getTime() - 86400000);
                    disabledRanges.push([rangeStart, rangeEnd]);
                    rangeStart = null;
                }
            }
            currentDate.setDate(currentDate.getDate() + 1);
        }
        if (rangeStart) {
            disabledRanges.push([rangeStart, futureDate]);
        }
        return disabledRanges;
    }
    formatDate(date) {
        const dateObj = date instanceof Date ? date : new Date(date);
        if (isNaN(dateObj.getTime())) {
            console.error('Invalid date provided to formatDate:', date);
            return '';
        }
        const year = dateObj.getFullYear();
        const month = String(dateObj.getMonth() + 1).padStart(2, '0');
        const day = String(dateObj.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }
    updateAvailableTimes(selectedDate) {
        const dateStr = this.formatDate(selectedDate);
        const timesForDate = this.availableDates[dateStr] || [];
        this.renderTimePeriods(timesForDate);
    }
    renderTimePeriods(times) {
        this.timePeriodsContainer.innerHTML = '';
        if (times.length === 0) {
            return;
        }
        // Check if there's only one time and it's 00:00
        const hasOnlyMidnight = times.length === 1 && times[0].time === '00:00';
        if (hasOnlyMidnight) {
            // Create hidden input for the 00:00 time
            const hiddenInput = document.createElement('input');
            hiddenInput.type = 'hidden';
            hiddenInput.name = 'time_period';
            hiddenInput.value = '00:00';
            hiddenInput.setAttribute('data-time', '00:00');
            this.timePeriodsContainer.appendChild(hiddenInput);
            // Auto-select the hidden time
            this.selectedTime = '00:00';
            return;
        }
        // Check if there's only one time option
        const hasOnlyOneTime = times.length === 1;
        const currentTime = this.container.getAttribute('data-current-time') || '';
        times.forEach(timeRow => {
            const fieldDiv = document.createElement('div');
            fieldDiv.className = 'form-field form-field-radio';
            const label = document.createElement('label');
            label.setAttribute('for', `time-${timeRow.time}`);
            const input = document.createElement('input');
            input.type = 'radio';
            input.name = 'time_period';
            input.id = `time-${timeRow.time}`;
            input.value = timeRow.time;
            input.setAttribute('data-time', timeRow.time);
            // Auto-check if there's only one time option
            if (hasOnlyOneTime || currentTime.includes(timeRow.time)) {
                input.checked = true;
                this.selectedTime = timeRow.time;
            }
            const span = document.createElement('span');
            span.textContent = this.formatDisplayTime(timeRow.time);
            label.appendChild(input);
            label.appendChild(span);
            fieldDiv.appendChild(label);
            this.timePeriodsContainer.appendChild(fieldDiv);
        });
    }
    formatDisplayTime(timeStr) {
        const [hours, minutes] = timeStr.split(':');
        const date = new Date();
        date.setHours(parseInt(hours, 10));
        date.setMinutes(parseInt(minutes, 10));
        return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false });
    }
    getTimeOptionsForSelectedDate() {
        if (!this.selectedDate || !this.availableDates) {
            return [];
        }
        const timesForDate = this.availableDates[this.selectedDate] || [];
        return timesForDate.map(timeRow => timeRow.time);
    }
}
